export const ALLIANCE_DAO_REQUEST_ACCESS_SOURCE = "/alliancedao" as const;
export const ALLIANCE_DAO_PROMO_CODE = "ALL1ANC326" as const;
export const DEFAULT_REQUEST_ACCESS_SOURCE = "request_access_page" as const;

export type RequestAccessSearch = {
  source?: typeof ALLIANCE_DAO_REQUEST_ACCESS_SOURCE;
};

export function parseRequestAccessSearch(
  search: Record<string, unknown>,
): RequestAccessSearch {
  return search.source === ALLIANCE_DAO_REQUEST_ACCESS_SOURCE
    ? { source: ALLIANCE_DAO_REQUEST_ACCESS_SOURCE }
    : {};
}

export function getRequestAccessSource(search: RequestAccessSearch): string {
  return search.source ?? DEFAULT_REQUEST_ACCESS_SOURCE;
}

export function getRequestAccessPromoCode(
  search: RequestAccessSearch,
): typeof ALLIANCE_DAO_PROMO_CODE | null {
  return search.source === ALLIANCE_DAO_REQUEST_ACCESS_SOURCE
    ? ALLIANCE_DAO_PROMO_CODE
    : null;
}
